import React from "react";
import { C, WEAKNESS } from "../lib/theme";
import { Wrench, Check, Lock } from "lucide-react";

export default function WeaknessCard({ weakness, onFix, side = "left", number, locked }) {
  const fixed = weakness.status === "fixed";
  const color = fixed ? C.grn : C.ros;
  return (
    <div
      data-testid={`weakness-card-${weakness.id}`}
      className={`relative w-full rounded-lg border p-3 shadow-lg transition-all ${fixed ? "" : "snap-in"}`}
      style={{ borderColor: color, background: `${color}12`, transform: `rotate(${side === "left" ? -1.5 : 1.5}deg)`, opacity: locked && !fixed ? 0.55 : 1 }}
    >
      <div className="mb-1 flex items-center justify-between">
        <span className="font-mono text-[10px] uppercase tracking-wider" style={{ color }}>
          {number != null && <span className="mr-1 opacity-70">ERROR #{number}</span>}
          {WEAKNESS[weakness.type] || weakness.type}
        </span>
        {fixed ? <Check className="h-3.5 w-3.5 text-grn" /> : locked && <Lock className="h-3 w-3 text-muted" />}
      </div>
      {weakness.quote && (
        <p className="mb-1.5 border-l-2 pl-2 text-xs italic text-ink/80" style={{ borderColor: color }}>"{weakness.quote}"</p>
      )}
      <p className="text-xs text-muted">{weakness.whatsMissing}</p>
      {!fixed && (
        locked ? (
          <div className="mt-2 inline-flex items-center gap-1 rounded-full border border-hair px-3 py-1 text-xs text-muted">
            <Lock className="h-3 w-3" /> Fix earlier errors first
          </div>
        ) : (
          <button
            data-testid={`fix-btn-${weakness.id}`}
            onClick={() => onFix(weakness)}
            className="press mt-2 inline-flex items-center gap-1 rounded-full border border-ros/50 bg-ros/10 px-3 py-1 text-xs font-medium text-ros hover:bg-ros/20"
          >
            <Wrench className="h-3 w-3" /> Learn & fix
          </button>
        )
      )}
    </div>
  );
}
